export default __webpack_public_path__ + "static/media/QuarterQuestion.b5972f1d.png";